import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {TemplatePreview} from "./template-preview.model";
import {TemplateGraphic} from "../template-graphic/template-graphic.model";

export interface PreviewImageResult {
    productId: number;
    productFaceId: number;
    productName: string;
    productColor: string;
    faceName: string;
    faceIndex: number;
    base64Image: string;
}

export interface GeneratePreviewImagesRequest {
    templateGraphics: Partial<TemplateGraphic>[];
    productIds: number[];
}

@Injectable({providedIn: 'root'})
export class TemplatePreviewService {
    constructor(private http: HttpClient) {
    }

    clone(id: number, cloneProducts: boolean): Observable<TemplatePreview> {
        return this.http.get<TemplatePreview>(
            `${environment.rootUrl}/template-preview/clone/${id}/${cloneProducts}`
        );
    }

    generatePreviewImages(request: GeneratePreviewImagesRequest): Observable<PreviewImageResult[]> {
        return this.http.post<PreviewImageResult[]>(
            `${environment.rootUrl}/template-preview/generate-preview-images`,
            request
        );
    }

    generatePreviewImagesZip(request: GeneratePreviewImagesRequest): Observable<Blob> {
        return this.http.post(
            `${environment.rootUrl}/template-preview/generate-preview-images-zip`,
            request,
            { responseType: 'blob' }
        );
    }
}
